import { axiosInstance } from '@/axiosInstance';
import { defineStore } from 'pinia';
import { useAccessDataStore } from './accessData';
import { usePurchaseCampaignsStore } from './purhaseCampaigns';
import { useGlobalStore } from './GlobalStore';
import { useAccessOperationsStore } from './accessOperations';

const VAT = 20;

export const useStripeStore = defineStore('useStripeStore', {
    state: () => ({
        sessionId: '',
        clientSecret: '',
    }),
    getters: {},
    actions: {
        async createCheckoutSession(): Promise<string> {
            try {
                const { amountToPay } = useAccessDataStore();
                const { brand } = useGlobalStore();
                const { quotation } = usePurchaseCampaignsStore();
                const { accessOperations } = useAccessOperationsStore();

                const billCode = [];
                const reference = [];
                for (const quot of quotation) {
                    billCode.push(quot.billCode);
                    reference.push(quot.quotationCode);
                }

                const data = {
                    amount: Number(((amountToPay * (100 + VAT)) / 100).toFixed(2)),
                    metadata: {
                        POI: accessOperations.pos_code,
                        billCode: billCode.join(','),
                        brand,
                        paymentType: 'full',
                        reference: reference.join(','),
                        access: true,
                    },
                };
                const response = await axiosInstance.post(`/payment/access/session/create-checkout`, data);
                this.sessionId = response.data.sessionId;
                this.clientSecret = response.data.clientSecret;
                return this.clientSecret;
            } catch (error) {
                console.error(error);
                throw error;
            }
        },
    },
});
